import { FC, ReactNode, useState } from 'react'
import { SidebarHandlers } from './SidebarHandlers'
import { Navigation } from 'features/Navigation'
import { AppLogo } from 'shared/images'
import { Text } from 'entities/Text'

import {
  SLabel,
  Drawer,
  MenuIcon,
  FakeCloser,
  MainContainer,
  AppIconWrapper,
  DrawerContainer,
  MenuIconContainer,
  DrawerInnerContainer
} from './styled'

export const DesktopSidebar: FC<{ children: ReactNode }> = ({ children }) => {
  //   const { themeColor } = useStore?.(appStore)

  const [isSideBarOpen, setIsSideBarOpen] = useState(false)
  return (
    <MainContainer>
      <Drawer variant='permanent' open={isSideBarOpen}>
        <DrawerContainer>
          <FakeCloser onClick={() => setIsSideBarOpen(false)} />
          <DrawerInnerContainer>
            <MenuIconContainer
              onClick={() => {
                setIsSideBarOpen((prevValue: boolean) => !prevValue)
              }}
            >
              <AppIconWrapper>
                <MenuIcon>
                  <AppLogo />
                </MenuIcon>
                <SLabel>
                  <Text sx={{ fontWeight: '700' }}>restaurant</Text>
                  <Text>Manager</Text>
                </SLabel>
              </AppIconWrapper>
            </MenuIconContainer>
            <Navigation />
          </DrawerInnerContainer>
          <SidebarHandlers />
        </DrawerContainer>
      </Drawer>
      {children}
    </MainContainer>
  )
}
